<template>
  <div class="login-container">
    <div class="zgc-title">{{ title }}</div>
    <div class="form-box">
      <div v-if="showLogin">
        <div class="welcome">欢 迎 登 陆</div>
        <el-form
          ref="loginForm"
          :model="loginForm"
          class="login-form"
          auto-complete="on"
          label-position="left"
        >
          <el-form-item prop="username" class="login-form-item">
            <span class="svg-container">
              <i class="iconfont iconuser1"></i>
            </span>
            <el-input
              ref="username"
              v-model="loginForm.username"
              placeholder="账号"
              name="username"
              type="text"
              tabindex="1"
              auto-complete="on"
            >
            </el-input>
          </el-form-item>

          <el-form-item prop="password" class="login-form-item">
            <span class="svg-container">
              <i class="iconfont iconpassword"></i>
            </span>
            <el-input
              :key="passwordType"
              ref="password"
              v-model="loginForm.password"
              :type="passwordType"
              placeholder="密码"
              name="password"
              tabindex="2"
              auto-complete="on"
              @keyup.enter.native="handleLogin"
            />
            <span class="show-pwd" @click="showPwd">
              <i
                :class="[
                  'iconfont',
                  passwordType === 'password' ? 'iconeye1' : 'iconeye',
                ]"
              ></i>
            </span>
          </el-form-item>
          <div>
            <el-button
              :loading="loading"
              type="primary"
              style="width: 100%"
              class="login-btn"
              @click="handleLogin"
              >登录</el-button
            >
          </div>
        </el-form>
      </div>
      <ModifyPwdForm v-else />
      <el-button type="text" @click="showLogin = !showLogin">{{
        showLogin ? "忘记密码" : "返回登陆"
      }}</el-button>
    </div>
    <div class="footer">
      <span>© 2023-2028 {{ title }} 技术支持：湖北盈诺网络科技有限公司 </span>
      <a
        target="_blank"
        href="https://beian.miit.gov.cn"
        style="margin-left: 10px"
        >鄂ICP备20007476号</a
      >
      <img src="../../image/ba.png" alt="" />
      <a
        target="_blank"
        style="margin-left: 5px"
        href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=42050202000528"
        >鄂公网安备 42050202000528号</a
      >
    </div>
    <div class="box" v-show="show" @click="bg">
      <div class="box-info">
        <div class="qrcode" ref="qrCodeUrl"></div>
      </div>
      <p class="title">请扫描二维码，进行人脸识别鉴权</p>
    </div>
  </div>
</template>

<script>
import AdminRoutes from "../../router/admin_routes";
import UserRoutes from "../../router/user_routes";
import routes from "../../router/routes.js";
import jwtDecode from "jwt-decode";
import QRCode from "qrcodejs2";
import config from "@/config";
import Storage from "../../utils/storage.js";
import { mapGetters } from "vuex";
import ModifyPwdForm from "./modifyPwdForm";
import Notice from "@/utils/notice";
export default {
  name: "Login",
  components: {
    ModifyPwdForm,
  },
  data() {
    return {
      loginForm: {
        username: "",
        password: "",
      },
      passwordType: "password",
      loading: false,
      show: false,
      userId: null,
      storage: null,
      orderNo: null,
      name: null,
      idNo: null,
      timer: null,
      title: "",
      showLogin: true,
      openStatus: 0,
    };
  },
  mounted() {
    this.storage = new Storage();
    // this.title = config.title;
  },
  computed: {
    ...mapGetters({
      storeUserInfo: "login/userInfo",
    }),
  },
  async created() {
    const res = await this.getOpeningConfig();
    if (res.data.code === "200") {
      if (res.data.data === null) {
        // 跳转到开通页面
        this.$router.replace({
          path: "/opening",
        });
      } else {
        this.title = res.data.data.appName;
        this.openStatus = res.data.data.openStatus;
        if (this.openStatus === 0) {
          // 跳转到开通页面
          this.$router.replace({
            path: "/opening",
          });
        }
      }
    }
  },
  destroyed() {
    // eslint-disable-next-line no-undef
    eventBus.$emit("openSocket");
    clearInterval(this.timer);
  },
  methods: {
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    creatQrCode(val) {
      // eslint-disable-next-line no-unused-vars
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: val, // 需要转换为二维码的内容
        width: 200,
        height: 200,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    bg() {
      this.show = false;
      this.$refs.qrCodeUrl.innerHTML = "";
      clearInterval(this.timer);
    },
    getFaceh5(data) {
      this.$api
        .Faceh5({ ...data })
        .then((res) => {})
        .catch(function (error) {
          console.log(error);
        });
    },
    getFacetResult() {
      this.$api
        .FacetResult({
          orderNo: this.orderNo,
          userId: this.userId,
        })
        .then((res) => {
          if (res.data.code === "200") {
            this.bg();
            localStorage.setItem("token", res.data.data);
            // 获取签名图片
            this.$store.dispatch("login/getSignImg");
            // 解析token
            let userInfo = jwtDecode(res.data.data);
            this.$store.commit("login/updateUserInfo", userInfo);
            // 获取权限
            this.getUserJurisdiction(this.storeUserInfo.id);
          } else {
            if (res.data.data.code !== "66660011") {
              this.bg();
              // this.$message.error(res.data.data.msg);
              this.$alert(res.data.data.msg, "认证失败", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch(function (error) {
          // eslint-disable-next-line no-console
          console.log(error);
        });
    },
    async handleLogin() {
      if (this.loginForm.username === "") {
        this.$message.error("手机号或用户名不能为空");
        return false;
      }
      if (this.loginForm.password === "") {
        this.$message.error("密码不能为空");
        return false;
      }

      const openRes = await this.getOpeningConfig();
      if (openRes.data.code === "200") {
        this.openStatus = openRes.data.data.openStatus;
      }

      if (this.openStatus === 2) {
        Notice.confirm({
          text: "法人还未签署开通协议，请先签署。或者重新申请开通。",
          confirmButtonText: "重新申请",
          cancelButtonText: "关闭",
          success: () => {
            this.$router.push({
              path: "/opening",
            });
          },
        });
        return;
      }
      this.loading = true;

      this.$api
        .login({
          username: this.loginForm.username,
          password: this.loginForm.password,
        })
        .then((res) => {
          if (res.data.code === "200") {
            let loginRespones = res.data;
            this.orderNo = loginRespones.orderNo;
            this.userId = loginRespones.userId;
            // if (loginRespones.flag === "0" || process.env.NODE_ENV === 'development') {
            //   localStorage.setItem("token", loginRespones.data);
            //   // 获取签名图片
            //   this.$store.dispatch("login/getSignImg");
            //   // 解析token
            //   let userInfo = jwtDecode(loginRespones.data);
            //   this.$store.commit("login/updateUserInfo", userInfo);
            //   // 获取权限
            //   this.getUserJurisdiction(this.storeUserInfo.id);
            //   return;
            // }
            if (loginRespones.flag === "0") {
              localStorage.setItem("token", loginRespones.data);
              // 获取签名图片
              this.$store.dispatch("login/getSignImg");
              // 解析token
              let userInfo = jwtDecode(loginRespones.data);
              this.$store.commit("login/updateUserInfo", userInfo);
              // 获取权限
              this.getUserJurisdiction(this.storeUserInfo.id);
              return;
            }

            // 人脸识别
            if (
              this.storage.getItem("token") === null ||
              this.storage.getItem("token") === false
            ) {
              let base64IdNo = window.btoa(loginRespones.idNo); // 把身份证base64一下

              let host = window.location.host;

              this.url = `http://${host}/#/auth/face?idNo=${base64IdNo}&name=${loginRespones.name}&userId=${loginRespones.userId}&orderNo=${loginRespones.orderNo}`;
              let callbackUrl = this.url;
              console.log(callbackUrl);
              this.creatQrCode(callbackUrl);
              this.show = true; //弹框二维码

              this.timer = setInterval(() => {
                this.getFacetResult();
              }, 10000);

              const time = 1000 * 60 * 1.5;
              setTimeout(() => {
                this.bg();
              }, time);
            } else {
              let temRoutes = AdminRoutes;
              this.$router.push({ path: temRoutes[0].redirect });
            }
          } else {
            this.$message({
              message: res.data.msg,
              type: "warning",
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },


    // 去注册
    gotoRegister() {
      this.$router.replace({
        path: "/register",
      });
    },
    gotoChangePassword() {
      this.$router.replace({
        path: "/changepassword",
      });
    },
    // 获取权限
    getUserJurisdiction(userId) {
      this.$api.getUserJurisdiction(userId).then((res) => {
        if (res.data.code === "200") {
          let obj = {
            user: {
              add: false,
              list: false,
              update: false,
              info: false,
              delete: false,
            },
          };
          res.data.data.find((value) => {
            if (value === "sys:user:save") {
              obj.user.add = true;
            }
            if (value === "sys:user:list") {
              obj.user.list = true;
            }
            if (value === "sys:user:update") {
              obj.user.update = true;
            }
            if (value === "sys:user:info") {
              obj.user.info = true;
            }
            if (value === "sys:user:delete") {
              obj.user.delete = true;
            }
          });
          this.$store.commit("login/updateJurisdiction", obj);

          let temRoutes;

          if (obj.user.list) {
            localStorage.setItem("roleType", "0");
            temRoutes = AdminRoutes;
          } else {
            localStorage.setItem("roleType", "1");
            temRoutes = UserRoutes;
          }

          routes.push(...temRoutes);
          this.$router.options.routes = routes;
          this.$router.addRoutes(routes);

          this.$router.push({ path: temRoutes[0].redirect });
        }
      });
    },
    // 电子签登陆接口
    async dzqLogin() {
      return this.$api.dzqLogin({
        loginMobile: this.loginForm.username,
        pwd: this.loginForm.password,
      });
    },
    // 获取公证处登陆开通信息
    async getOpeningConfig() {
      return this.$api.getOpeningConfig();
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../style/iconfont.css";
@import "../../style/mixin";

.zgc-title {
  font-size: 36px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #ffffff;
  position: absolute;
  top: 93px;
  @media screen and (max-width: 2000px) {
    left: 15%;
  }
  @media screen and (min-width: 2000px) and (max-width: 2500px) {
    left: 20%;
  }
  @media screen and (min-width: 2500px) {
    left: 25%;
  }

  letter-spacing: 5px;
}
.login-btn {
  height: 40px;
  background: #1f8df2;
  border-radius: 20px;
  // background: linear-gradient(
  //   93deg,
  //   rgba(61, 219, 247, 1),
  //   rgba(38, 123, 228, 1)
  // );

  // border-radius: 23px;
  border: none;
}
.login-container {
  width: 100%;
  height: 100vh;
  background-color: #1c89f0;
  background-image: url("../../image/bg.png");
  // background-position: left center;
  @media screen and (max-width: 2000px) {
    background-position: left center;
  }
  @media screen and (min-width: 2000px) and (max-width: 2500px) {
    background-position: 25% center;
  }
  @media screen and (min-width: 2500px) {
    background-position: 35% center;
  }
  background-size: auto 100%;
  position: relative;
  background-repeat: no-repeat;
  .form-box {
    box-shadow: 0px 3px 14px 0px rgba(59, 59, 59, 0.3);
    .welcome {
      font-size: 30px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #1f8df2;
      text-align: center;
      margin: 40px 0;
    }
    width: 500px;
    height: 400px;
    background: rgba(255, 255, 255, 1);
    border-radius: 15px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    @media screen and (max-width: 2000px) {
      right: 15%;
    }
    @media screen and (min-width: 2000px) and (max-width: 2500px) {
      right: 20%;
    }
    @media screen and (min-width: 2500px) {
      right: 50%;
      transform: translate(700px, -50%);
    }

    // transform: translate(-50%, -50%);
    padding: 0 85px;
    box-sizing: border-box;
    i {
      color: rgba(31, 141, 242, 0.5);
    }
  }
}
.box {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  position: absolute;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .box-info {
    margin-bottom: 10px;
  }
  .qrcode {
    // display: flex;
    // flex-direction: column;

    img {
      display: block;
      width: 400px;
      height: 400px;
      background-color: #fff; //设置白色背景色
      padding: 6px; // 利用padding的特性，挤出白边
      box-sizing: border-box;
      margin-bottom: 20px !important;
    }
    &::before {
      content: "";
      width: 300px;
      height: 300px;
      display: block;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: #fff;
      z-index: -1;
      border-radius: 5px;
    }
    // &::after {
    //   content: "";
    //   width: 300px;
    //   height: 20px;
    //   display: block;
    //   position: absolute;
    //   bottom: 10px;
    //   left: 50%;
    //   transform: translatex(-50%);
    //   background: #fff;
    //   z-index: -1;
    // }
  }
  .title {
    font-size: 12px;
  }
}
.footer {
  width: 100%;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #ffffff;
  line-height: 22px;
  opacity: 0.8;
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translatex(-50%);
  .flex(center);
  a {
    margin-left: 10px;
    color: #ffffff;
  }
  img {
    margin-left: 10px;
  }
}
/deep/ .login-form-item {
  height: 40px;
  padding: 0 20px;
  background: #ffffff;
  border: 1px solid rgba(31, 141, 242, 0.5);
  // opacity: 0.5;
  border-radius: 20px;

  .el-input__inner {
    opacity: 1;
    border: none;
    width: 100%;
    height: 40px;
    // color: red !important;
  }
  .el-form-item__content {
    width: 100%;
    .flex();
    height: 40px;
  }
}
/deep/ .iconfont {
  color: rgba(31, 141, 242, 0.5);
}
</style>
